/* eslint-disable */
/* Vue directive to validate all required fields with error messages */
export default {
    inserted: function (el, binding, vnode) {

        var forms = el;
        const button = forms.querySelector('[type=submit]');
        const required = forms.querySelectorAll('input[required="required"]')
        const telephone = forms.querySelectorAll('input[type="tel"], [id^=phone]');
        const phoneFormat = RegExp(/^(\d{3})-(\d{3})-(\d{4})$/);
        const zipFormat = RegExp(/^\d{5}$|^\d{5}-\d{4}$/);
        button.disabled = true;

        
        const validateForm = (el) => {
            if (el && el.validity.valid === false) {
                if (el.nextElementSibling !== null && (el.nextElementSibling.classList.contains('invalid-feedback') || el.nextElementSibling.classList.contains('Invalid-Feedback'))) {
                    el.nextElementSibling.classList.add('d-block');
                }
            }

            if (el && el.validity.valid === true) {
                if (el.nextElementSibling !== null && (el.nextElementSibling.classList.contains('invalid-feedback') || el.nextElementSibling.classList.contains('Invalid-Feedback'))) {
                    el.nextElementSibling.classList.remove('d-block');
                }
            }

            if (forms.checkValidity() === false) {
                button.disabled = true;
            } else {
                button.disabled = false;
            }
        }

        // Email validation message
        const validateEmail = (el) => {
            if (el.validity.valid === false) {
                if (el.nextElementSibling !== null && el.nextElementSibling.classList.contains('invalid-feedback')) {
                    el.nextElementSibling.classList.toggle('d-block');
                }
            }
            // email validation for doctor quiz 
        }

        // Telephone validation message
        const validatePhone = (el) => {
            if(el.value.length === 0) {
                el.setCustomValidity('');
            }

            let isFormatted = phoneFormat.test(el.value);

            if(isFormatted) {
                el.setCustomValidity('');
            } else if(el.value.length > 0) {
                el.setCustomValidity('Please provide a valid Phone.');
            }
            
            if (el.validity.valid === false) {
                if (el.nextElementSibling !== null && (el.nextElementSibling.classList.contains('invalid-feedback') || el.nextElementSibling.classList.contains('Invalid-Feedback'))) {
                    el.nextElementSibling.classList.add('d-block');
                }
            }

            if (el.validity.valid === true) {
                if (el.nextElementSibling !== null && (el.nextElementSibling.classList.contains('invalid-feedback') || el.nextElementSibling.classList.contains('Invalid-Feedback'))) {
                    el.nextElementSibling.classList.remove('d-block');
                }
            }
        }

        const validateZip = (el) => {
            let isFormatted = zipFormat.test(el.value)

            if(isFormatted) {
                el.setCustomValidity('');
            } else {
                el.setCustomValidity('Zipcode Required.');
            }
            
            if (el.validity.valid === false) {
                if (el.nextElementSibling !== null && (el.nextElementSibling.classList.contains('invalid-feedback') || el.nextElementSibling.classList.contains('Invalid-Feedback'))) {
                    el.nextElementSibling.classList.add('d-block');
                }
            }

            if (el.validity.valid === true) {
                if (el.nextElementSibling !== null && (el.nextElementSibling.classList.contains('invalid-feedback') || el.nextElementSibling.classList.contains('Invalid-Feedback'))) {
                    el.nextElementSibling.classList.remove('d-block');
                }
            }
        }

        for (const req of required) {
            req.addEventListener('change', function (evt) {
                if (req.required === true) {
                    validateEmail(req);
                }
                validateForm();
            });
        }

        for (const form of forms) {
            form.addEventListener('input', function (evt) {
                if(form.required === true && form.value === '') {
                    form.setCustomValidity('Please provide a valid response.');
                } else {
                    form.setCustomValidity('');
                }
                if(form.required === true && form.id.startsWith('zipcode')) {
                    validateZip(form)
                }
                // For non-required zip code in course search component
                if(form.id === 'zipcode' && form.value.length > 0) {
                    validateZip(form)
                }
                validateForm(form);
            });

            form.addEventListener('blur', function (evt) {
                if(form.required === true && form.value === '') {
                    form.setCustomValidity('Please provide a valid response.');
                } else {
                    form.setCustomValidity('');
                }
                if(form.required === true && form.id.startsWith('zipcode')) {
                    validateZip(form)
                }
                // For non-required zip code in course search component
                if(form.id === 'zipcode' && form.value.length > 0) {
                    validateZip(form)
                }
                validateForm(form);
            });

            form.addEventListener('change', function (evt) {
                if(form.required === true && form.value === '') {
                    form.setCustomValidity('Please provide a valid response.');
                } else if(form.required === true && form.value.length > 0) {
                    form.setCustomValidity('');
                }
                validateForm(form);
            });
        }

        for (const tel of telephone) {
            tel.addEventListener('blur', function(evt) {
                validatePhone(evt.target);
                validateForm();
            });
        }

        // Check form on load
        validateForm();
    }
};




// WEBPACK FOOTER //
// ./src/app/directives/form-validate.js